import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { PrioritySkillSets } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/taxonomy/base-url';
import type { SkillDesignation } from '@/models/taxonomy/skills';

export const useUserPrioritySkillSetsIndex = () => {
  const response = useQuery<PrioritySkillSets>({
    queryKey: [clientKeys.useUserPrioritySkillSetsIndex],
    queryFn: async () =>
      falconClient.get(`${baseUrl}/user_priority_skill_sets`),
  });

  return {
    prioritySkillSets: response.data?.skills || [],
    selectedSkills: response.data?.skill_designations || [],
    ...response,
  };
};

export const useEditUserPrioritySkillSets = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (SkillDesignations: SkillDesignation[]) =>
      falconClient.put(`${baseUrl}/user_priority_skill_sets`, {
        user_priority_skill_set: {
          skill_designations: SkillDesignations.map((s) => ({
            skill_id: s.skill.id,
            score: s.score ?? 1,
            label: s.label ?? undefined,
          })),
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useUserPrioritySkillSetsIndex],
      });
      queryClient.resetQueries({
        queryKey: [clientKeys.useCourseRecommendations],
      });
    },
  });
};
